import { createSlice } from "@reduxjs/toolkit"
import { getUser, getUsers, login, logout } from "../actions/user"
import { UserInfo } from "../../interfaces/user-info"

interface InitialState {
    user: UserInfo | null,
    users: UserInfo[] | null,
    loginError: string | null,
    isLoading: boolean
}

const initialState: InitialState = {
    user: null,
    users: null,
    loginError: null,
    isLoading: true
}

export const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        removeLoginError: (state) => {
            state.loginError = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(logout.pending, (state,) => {
                state.isLoading = true;
            })
            .addCase(logout.fulfilled, (state,) => {
                state.user = null;
                state.isLoading = false;
            })
            .addCase(login.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(login.fulfilled, (state, { payload }) => {
                state.user = payload;
                state.isLoading = false;
            })
            .addCase(login.rejected, (state, {payload}) => {
                if (payload) {
                    state.loginError = payload;
                }
                state.isLoading = false;
            })
            .addCase(getUser.pending,(state) => {
                state.isLoading = true;
            })
            .addCase(getUser.fulfilled,(state, { payload }) => {
                state.user = payload;
                state.isLoading = false;
            })
            .addCase(getUser.rejected,(state) => {
                state.isLoading = false;
            })
            .addCase(getUsers.fulfilled,(state, { payload }) => {
                state.users = payload.users;
            })
    },
})

export const {removeLoginError} = userSlice.actions